import * as React from 'react';
import { History } from 'history';
import Model from './transactiondetail-model';
import BasePicklistCard from '../base/base-picklistcard.component';

interface IProps { 
  history: History;
  caption?: string;
  nodataCaption ?: string;
  productId?: number;
  transactionId?: number;
  transactionStatus?: string;
  currentId?: number;
  cardCount?: number;
  pageSize?: number;
  swipe?: string;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any) => void;
  disableSearch?: boolean;
}

interface IState {
}

export default class TransactiondetailPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    if (this.props.onLoad) {
      var value = 0;
      var qty = 0;
      data.forEach((datarow: { value: number; qty: number }, i: any) => {
        value = value + datarow.value;
        qty = qty + datarow.qty;
      });
      this.props.onLoad({'total': {'value' : value, 'qty': qty}});
    } 
    this.props.onLoadAll?.(data);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} nodataCaption ={this.props.nodataCaption } endPointFilter={Model.endPointFilterList(this.props.productId, this.props.transactionId, this.props.transactionStatus)} model={Model} currentId={this.props.currentId} onLoadAll={this.onLoadAll} header={!this.props.transactionId && Model.columnPicklistCardReview} pageSize={this.props.pageSize} searchField={this.props.disableSearch? ' ' : ''} cardCount={this.props.cardCount} swipe={this.props.swipe} autoLoad disableBackButton disableCard/>
    );
  }
}
